<div [class.isPrinting]="printService.isPrinting">
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="medium"
               color="#000000"
               type="ball-spin-clockwise">
  </ngx-spinner>

  <div class="office-hr-wrapper" *ngIf="ListView">
    <div class="row">
      <div class="col-md-12 padding-right-0px padding-left-0px margin-top-10">
        <div class="office-hr-card">
          <div class="office-hr-header">
            <h3 class="office-hr-title">
              <i class="fas fa-file-medical-alt"></i> Health Records
            </h3>
            <div>
              <button (click)="AddForm()" class="office-btn-primary" title="Click here to add new form">
                <i class="fas fa-plus font-size-11"></i> Add Form
              </button>
            </div>
          </div>
          <div class="card-body padding-all-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-md-12 padding-all-0px">
                <div class="table-component">
                  <div class="table-responsive overflow-x-hidden">
                    <table class="office-hr-table">
                      <thead>
                        <tr>
                          <th style="width: 170px;">Date</th>
                          <th>Form Name</th>
                          <th style="width: 200px; text-align: right;">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let l of CurrentOTFormsByFormattedCodeController">
                          <td>
                            <span class="hr-date-badge">
                              <i class="far fa-calendar-alt margin-right-6px"></i>{{l.PatientReportDate|date:'dd-MM-yyyy'}}
                            </span>
                          </td>
                          <td>
                            <span class="hr-form-title">
                              <i class="fas fa-file-medical margin-right-8px"></i>{{l.TemplateName}}
                            </span>
                          </td>
                          <td style="text-align: right;">
                            <div class="action-btn-cell">
                              <button (click)="OpenForm(l)" class="office-btn-secondary" title="Open Form">
                                <i class="fas fa-folder-open"></i> Open
                              </button>
                              <button (click)="DeleteForm(l)" class="office-btn-danger" title="Delete Form">
                                <i class="far fa-trash-alt"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr *ngIf="!CurrentOTFormsByFormattedCodeController || CurrentOTFormsByFormattedCodeController.length === 0">
                          <td colspan="3" class="text-align-center padding-all-20px color-text-muted font-weight-500">
                            <i class="fas fa-folder-open font-size-24px margin-bottom-8px display-block" style="color: #c8c6c4;"></i>
                            No health records found. Click <strong>+ Add Form</strong> above to create a new form.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--<div *ngIf="isRequesting">

    <div class="loader-text">
      <div class="loader-text2">

        <div class="lds-facebook">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="margin-top-20px margin-left-5px">
          <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
        </div>

      </div>
    </div>


  </div>-->

  <div class="office-hr-wrapper" *ngIf="FormList">
    <div class="row">

      <div class="col-md-12 padding-left-0px padding-right-0px">
        <div class="row margin-left-0px">

          <div class="col-md-8 frameless-form-panel">
            <div class="office-form-header">
              <h3 class="office-form-title">
                <a class="back-arrow-link" title="Back To Health Records" (click)="BackToHealthrecords()">
                  <i class="fas fa-angle-double-left font-size-19px"></i>
                </a>
                <span>{{TemplateName}}</span>
              </h3>
              <div class="action-btn-group">
                <button type="button" class="office-btn-secondary margin-right-5px" (click)="printfclinical()">
                  <i class="fa fa-print font-size-12px"></i> A4
                </button>
                <button type="button" class="office-btn-secondary" (click)="printfclinicalnoheader()">
                  <i class="fa fa-print font-size-12px"></i> No Header
                </button>
              </div>
            </div>

            <!-- Scrollable Body for Form Display Area -->
            <div class="office-form-scroll-body">
              <div *ngIf="fo && fo.AutoSections">
                <div class="col-md-12">
                  <div class="row margin-left-auto">
                  <div class="col-md-12 padding-l-0px" *ngFor="let section of  fo.AutoSections;let RowIndex = index">
                    <div class="card margin-left-0px margin-right-0px margin-bottom-5px">
                      <div [id]="'title_num_'+ RowIndex" class="margin-bottom-30px"></div>
                      <!--<label class="red-bg">{{section.SectionType}} , Children Count:{{section.Fields.length}}</label>-->
                      <!--<div *ngIf="field.isHeader && (field.ValueType == null || field.ValueType == 'List')">
                        <h4 class="font-size-18px margin-bottom-0px color-Assign"> {{field.Title}}</h4>


                      </div>-->
                      <div [id]="'accordion'+RowIndex">
                        <div [ngSwitch]="section.SectionType">


                          <!--<label class="red-bg blue">{{field.Data.Title}} , Field Type:{{field.Data.ValueType}}</label>-->
                          <div class="card-header wh-header font-size-16px  padding-top-2px padding-bottom-2px border-left-clinical padding-l-8px padding-right-0px font-weight-normal2 font-size-16px card-header-bg" [id]="'heading'+RowIndex">
                            <div class="row" id="edit-link">
                              <div class="col-md-3">
                                <h5 class="mb-0">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                          aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                                    {{section.Data.Title}}

                                  </button>

                                </h5>
                              </div>
                              <div class="col-md-9 display-edit">
                                <a class="nav-link-hand float-right education-navlink margin-right-10px " *ngIf="section.SectionType == 'AttrVal'" title="Edit" (click)="displyeditattr(section.Data)">
                                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                                <a class="nav-link-hand float-right education-navlink margin-right-10px " *ngIf="section.SectionType == 'Text' " title="Edit" (click)="displyeditText(section.Data)">
                                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                                <a class="nav-link-hand float-right education-navlink margin-right-10px " *ngIf="section.SectionType == 'Image'" title="Edit" (click)="displyeditImage(section.Data)">
                                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                                <!--<a class="nav-link-hand float-right education-navlink margin-right-10px " title="Edit" (click)="displytextview()">
                                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                </a>-->
                              </div>
                            </div>


                          </div>
                          <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                               [attr.data-parent]="'#accordion'+RowIndex">

                            <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">
                              <div class="row" *ngSwitchCase="'AttrVal'">
                                <div class="col-md-12 padding-l-0px padding-right-0px" *ngFor="let field of  section.Fields">


                                  <div [ngSwitch]="field.Data.ValueType">
                                    <div class="row" *ngSwitchCase="'Bool'">
                                      <auto-gen-bool class="col-md-12" [Data]="field" [field]="field.Data"
                                                     mode="view">
                                      </auto-gen-bool>
                                    </div>
                                    <div class="row" *ngSwitchCase="'List'">
                                      <auto-gen-list class="col-md-12 padding-l-0px padding-right-0px" [Data]="field" [field]="field.Data"
                                                     mode="view">
                                      </auto-gen-list>
                                    </div>
                                    <div class="row margin-top-5px" *ngSwitchCase="'Text'">
                                      <auto-gen-text class="col-md-12" [field]="field.Data" mode="view"></auto-gen-text>
                                    </div>
                                    <div class="row margin-top-5px" *ngSwitchCase="'CVS'">
                                      <auto-gen-cvs class="col-md-12" [field]="field.Data" mode="view"></auto-gen-cvs>
                                    </div>
                                    <div class="row margin-top-5px" *ngSwitchCase="'CsvList'">
                                      <auto-gen-csvlist class="col-md-12" [field]="field.Data" [Data]="field" mode="view"></auto-gen-csvlist>
                                    </div>
                                    <div class="row" *ngSwitchCase="'Date'">
                                      <auto-gen-date class="col-md-12" [field]="field.Data" mode="view"></auto-gen-date>
                                    </div>
                                    <div class="row padding-bottom-10px" *ngSwitchCase="'Grid'">
                                      <!--<label>Grid: {{field.Title}}</label>-->
                                      <auto-gen-grid class="col-md-12" [field]="field" mode="view"></auto-gen-grid>
                                    </div>

                                    <div class="row" *ngSwitchDefault>




                                    </div>





                                  </div>
                                </div>
                              </div>
                              <div class="row" *ngSwitchCase="'Text'">
                                <div class="col-md-12 padding-l-0px padding-right-0px">
                                  <!--*ngFor="let field of  section.Fields"-->

                                  <div class="row">
                                    <div class="col-md-12 " *ngFor="let field of section.Data.Fields">
                                      <div class="row" *ngIf="field.ValueType=='Text'">

                                        <div class="col-md-11 padding-left-0px padding-right-0px">

                                          <textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" placeholder="Remarks"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="field.Value" maxlength="600"></textarea>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row" *ngSwitchCase="'Image'">
                                <div class="col-md-12 padding-l-0px padding-right-0px">
                                  <!--*ngFor="let field of  section.Fields-->

                                  <div class="row">
                                    <div class="col-md-12">
                                      <div class="table-component">
                                        <div class="table-responsive">


                                          <table class="table table-striped margin-left-zero">

                                            <!--<thead class="">
                                              <tr>
                                                <th class="min-width-0px width-57px padding-top-4px padding-bottom-4px"></th>

                                                <th class="width-53px padding-top-4px padding-bottom-4px">#</th>
                                                <th class="width-178px padding-top-4px padding-bottom-4px">Title</th>
                                                <th class="padding-top-4px padding-bottom-4px">Image</th>

                                                <th class="padding-top-4px padding-bottom-4px">Comments</th>
                                                <th class="padding-top-4px padding-bottom-4px"></th>
                                              </tr>
                                            </thead>-->
                                            <tbody class="table-body">

                                              <tr *ngFor="let field of section.Data.Fields; let RowIndex = index ">
                                                <!--<td class="padding-top-0px padding-bottom-0px ">

                                                  <input type="checkbox" [(ngModel)]="field.IsSelected" />
                                                  <i class="input-helper"></i>

                                                </td>-->
                                                <td class="padding-top-0px padding-bottom-0px ">{{RowIndex+1}}</td>

                                                <td class="padding-top-0px padding-bottom-0px ">
                                                  <!--<input class="form-control " [(ngModel)]="field.Title" type="text" [ngModelOptions]="{standalone: true}" />-->
                                                  <div><label class="margin-bottom-0px">{{field.Title}}</label></div>
                                                  <div><label class="margin-bottom-0px"> {{field.Remarks}}</label></div>
                                                </td>
                                                <td class="padding-top-0px padding-bottom-0px padding-left-5px">

                                                  <!--<div *ngIf="!field.HasImage">
                                                    <button class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save">
                                                      <i class="fas fa-ellipsis-h"></i>
                                                    </button>
                                                  </div>-->
                                                  <div *ngIf="field.HasImage">
                                                    <img class="img-circle-56 font-size-12px" [src]="field.ImageFile" onError="this.src='dummy.jpg';">
                                                    <!--<button type="button" class="btn  btn-sm button-new-health margin-top-left" tooltip="Add" (click)="openDocContent(field)" *ngIf="field?.IsSelected"><i class="fas fa-plus nav-link-hand"></i></button>-->

                                                  </div>
                                                </td>
                                                <!--<td class="padding-top-0px padding-bottom-0px">

                                                  {{field.Remarks}}

                                                </td>-->
                                                <!--<td class="text-align-right padding-top-0px padding-bottom-0px">

                                                  <a class="nav-link-hand font-size-20px margin-left-10px" title="Remove" *ngIf="field?.IsSelected"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>

                                                </td>-->



                                              </tr>

                                            </tbody>

                                          </table>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index" hidden>

              <div [id]="'accordion'+RowIndex">
                <div class="card-header wh-header font-size-16px  padding-top-2px padding-bottom-2px border-left-clinical padding-l-8px padding-right-0px font-weight-normal2 font-size-16px card-header-bg" [id]="'heading'+RowIndex">
                  <div class="row" id="edit-link">
                    <div class="col-md-3">
                      <h5 class="mb-0">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                          {{l.Title}}

                        </button>

                      </h5>
                    </div>
                    <div class="col-md-9 display-edit">
                      <a class="nav-link-hand float-right education-navlink margin-right-10px " *ngIf="l.SectionType == 'AttrVal'" title="Edit" (click)="displyeditattr(l)">
                        <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                      </a>
                      <a class="nav-link-hand float-right education-navlink margin-right-10px " *ngIf="l.SectionType == 'Text' " title="Edit" (click)="displyeditText(l)">
                        <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                      </a>
                      <a class="nav-link-hand float-right education-navlink margin-right-10px " *ngIf="l.SectionType == 'Image'" title="Edit" (click)="displyeditImage(l)">
                        <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                      </a>
                      <!--<a class="nav-link-hand float-right education-navlink margin-right-10px " title="Edit" (click)="displytextview()">
                        <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                      </a>-->
                    </div>
                  </div>


                </div>
                <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                     [attr.data-parent]="'#accordion'+RowIndex">
                  <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                    <div class="row col-md-12 card" *ngFor="let field of l.Fields">


                      <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="field.isHeader">
                        {{field.Title}}
                      </div>
                      <div *ngIf="field.Data"
                           class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                        <div [ngSwitch]="field.Data.ValueType">
                          <div class="row" *ngSwitchCase="'Bool'">
                            <auto-gen-bool class="col-md-12" [Data]="field" [field]="field.Data"
                                           mode="view">
                            </auto-gen-bool>
                          </div>
                          <div class="row" *ngSwitchCase="'List'">
                            <auto-gen-list class="col-md-12 padding-l-0px padding-right-0px" [Data]="field" [field]="field.Data">
                            </auto-gen-list>
                          </div>
                          <div class="row margin-top-5px" *ngSwitchCase="'Text'">
                            <auto-gen-text class="col-md-12" [field]="field.Data" mode="view"></auto-gen-text>
                          </div>
                          <div class="row margin-top-5px" *ngSwitchCase="'CVS'">
                            <auto-gen-cvs class="col-md-12" [field]="field.Data"></auto-gen-cvs>
                          </div>
                          <div class="row" *ngSwitchCase="'Date'">
                            <auto-gen-date class="col-md-12" [field]="field.Data"></auto-gen-date>
                          </div>
                          <div class="row" *ngSwitchCase="'Grid'">
                            <label>Grid: {{field.Title}}</label>
                            <!--<auto-gen-grid class="col-md-12" [field]="field.Data"></auto-gen-grid>-->
                          </div>
                          <div class="row" *ngSwitchDefault>
                            <!--<label class="red-bg">Other: {{field.Data.Title}} , Field Type:{{field.Data.ValueType}}</label>-->
                          </div>
                        </div>
                        <!--<div *ngIf="f.isSubHeader && !f.isTextField">
                          <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                        </div>
                        <div *ngIf="f.isTextField">
                          <div class="row">
                            <div class="col-md-2 ">
                              <label class="font-size-12px margin-bottom-0px">{{f.Title}}</label>
                            </div>:
                            <div class="col-md-5">
                              <label class="font-size-12px margin-bottom-0px"> {{f.Value}}</label>
                            </div>
                          </div>


                        </div>
                        <div *ngIf="f.isSubChild">
                          <div class="row">
                            <div class="col-md-6">
                              <label class="font-size-12px margin-bottom-0px" id="image">{{f.Title}}</label>
                            </div>:
                            <div class="col-md-5">
                              <label class="font-size-12px margin-bottom-0px"> {{f.Value}}</label>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="f.Remarks">
                          <label class="margin-left-10px margin-bottom-0px" id="image">{{f.Remarks}}</label>
                        </div>
                        <div *ngIf="f.HasSeparator">
                          <div class="border-bottom-light"></div>
                        </div>-->
                      </div>
                    </div>



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 vertical-panel-splitter">
          <div class="position-fixed-Activities">
            <div class="card">
              <div class="card-header border-left-clinical font-size-16px border-top-1px border-right-1px border-bottom-1px border-radius-5px wh-header padding-top-3px padding-bottom-3px padding-right-0px padding-left-9px">
                Document Information
              </div>
              <div class="card-body padding-top-0px padding-left-0px padding-right-0px margin-left-0px">
                <div class=" margin-top-5px border-bottom-4px-document">
                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right padding-right-10px">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px">Document Name</label>
                    </div>:
                    <div class="col-md-7 font-size-12px font-weight-normal">
                      <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{TemplateName}}</label>

                    </div>
                  </div>

                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px">Date</label>
                    </div>:
                    <div class="col-md-5 font-size-12px font-weight-normal">
                      <label *ngIf="Date" class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{Date|date:'dd-MM-yyyy'}}</label>

                    </div>
                  </div>
                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px">Sign1</label>
                    </div>:
                    <div class="col-md-5 font-size-12px margin-top-5px font-weight-normal">
                      <label *ngIf="Sign1" class="font-size-14 font-weight-normal margin-bottom-0px">{{Sign1}}</label>

                    </div>
                  </div>
                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px"> Sign2 </label>
                    </div>:
                    <div class="col-md-5 font-size-12px font-weight-normal">

                      <label *ngIf="Sign2" class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{Sign2}}</label>
                    </div>
                  </div>
                </div>

                <div class="accordion" id="accordionExample">
                  <div class="card margin-bottom-5px">
                    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                      <div class="row">
                        <div class="col-md-5">
                          <h5 class="mb-0 height-24px">
                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              Document Sections
                            </button>
                          </h5>
                        </div>

                      </div>


                    </div>

                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                      <div class="document-sections-list">
                        <a class="doc-section-link" *ngFor="let section of (fo && fo.Sections && fo.Sections.length > 0 ? fo.Sections : []); let RowIndex = index"
                           (click)="gotolink(section.Title || section.Data?.Title, RowIndex)">
                          <i class="fas fa-bookmark doc-section-icon"></i>
                          <span>{{section.Title || section.Data?.Title}}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>








  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>

<!--<div class="row" *ngIf="Formedit">
  <div class="col-md-8 padding-left-0px">


    <div class="card">

      <div class="card-body padding-all-0px">
        <div *ngIf="FormData" class="margin-top-10">


          <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index">

            <div [id]="'accordion'+RowIndex">
              <div class="card-header wh-header font-size-16px  padding-top-6px padding-bottom-6px card-header-bg border-left-clinical padding-l-8px padding-right-8px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                <div class="row">
                  <div class="col-md-3">
                    <h5 class="mb-0">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                              aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                        {{l.Title}}

                      </button>

                    </h5>
                  </div>
                  <div class="col-md-9">
                    <button type="submit" class="btn actions-btn-prime float-right">Save</button>
                    <button type="button"
                            (click)="Backtolist()" class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right margin-right-10px">
                      Cancel
                    </button>
                  </div>
                </div>


              </div>
              <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                   [attr.data-parent]="'#accordion'+RowIndex">
                <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                  <div class="row col-md-12 card" *ngFor="let f of l.Fields">


                    <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="f.isHeader">
                      {{f.Title}}
                    </div>
                    <div class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                      <div *ngIf="f.isSubHeader">
                        <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                      </div>


                      <div *ngIf="f.isTextField">
                        <div class="row form-group">
                          <div class="col-md-3 padding-right-0px text-align-right">
                            <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                          </div>
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                          </div>
                        </div>


                      </div>
                      <div *ngIf="f.isSubChild">
                        <div class="row form-group">
                          <div class="col-md-3 text-align-right">
                            <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                          </div>:
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                          </div>
                        </div>
                      </div>


                      <div *ngIf="f.Remarks">
                        <label class="margin-left-10px margin-bottom-0px">{{f.Remarks}}</label>
                      </div>
                      <div *ngIf="f.HasSeparator">
                        <div class="border-bottom-light"></div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">

  </div>
</div>-->
<!--<div class="row">
  <div class="col-md-12">
    <medicalrecordview [FormattedCode]="FormattedCode" *ngIf="viewhealthrecord"></medicalrecordview>
  </div>

</div>-->
